import { render } from "./DiagnostFactors.vue?vue&type=template&id=186bf4cc&scoped=true"
import script from "./DiagnostFactors.vue?vue&type=script&lang=js"
export * from "./DiagnostFactors.vue?vue&type=script&lang=js"

import "./DiagnostFactors.vue?vue&type=style&index=0&id=186bf4cc&scoped=true&lang=css"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186bf4cc"]])

export default __exports__